module.exports = __webpack_public_path__ + "img/failed.5d7156d5.svg";